<template>
  <b-modal :id="id" footer-class="justify-content-start" size="xl">
    <template v-slot:modal-title>
      <div class="d-flex">
        <h4 class="py-3 px-1 mb-0 font-weight-boldy">
          History for {{ selectedCustomer?.customerName }}
        </h4>
      </div>
    </template>
    <b-container fluid>
      <b-row class="mb-3">
        <b-col class="px-1" cols="12">
          <p style="max-width: 690px">
            Below is a timeline of the most recent whitelist management history
            regarding customer with ID
            <code>{{ selectedCustomer?.customerId }}</code
            >.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <R-MilestoneTracker :milestones="milestones" :theme="theme" />
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ cancel }">
      <R-Button :size="'small'" @onClick="cancel()">Close</R-Button>
    </template>
  </b-modal>
</template>
<script>
import computeMilestonesForSelectedCustomer from "./milestones";

export default {
  name: "LogsModal",
  props: {
    id: {
      required: true,
    },
    selectedCustomer: {
      required: true,
    },
  },
  data() {
    return {
      theme: {},
    };
  },
  computed: {
    milestones() {
      return computeMilestonesForSelectedCustomer(this.selectedCustomer);
    },
  },
};
</script>
